import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContractProcessResult } from '@shared-logic/integration-ibm';
import { Subscription } from 'rxjs';
import { setModalContract } from 'src/app/redux/actions/options.action';
import { appState } from 'src/app/shared/interfaces/appState.interface';

@Component({
  selector: 'dialog-contract-failed',
  templateUrl: './contract-failed.component.html',
  styleUrls: ['./contract-failed.component.scss', './../modal.scss', './../../../shared/styles/table.scss']
})
export class ContractFailedComponent implements OnInit, OnDestroy {
  showModal: boolean = false;
  arrayOfFailed: ContractProcessResult[] = []; //Array con la información del o los errores
  isIndicators: boolean = false; //Vamos a mostrar error de los indicadores
  private options$!: Subscription;

  constructor(private store: Store<appState>) { }

  ngOnInit(): void {
    this.options$ = this.store.select('options').subscribe(optionsR => {
      this.showModal = optionsR.modalContract.isShow && optionsR.modalContract.arrayOfFaileds.length > 0;
      this.arrayOfFailed = optionsR.modalContract.arrayOfFaileds;
      this.isIndicators = optionsR.modalContract.isIndicators;
    })
  }

  ngOnDestroy() {
    this.options$.unsubscribe();
  }

  getArrayOfMessage(failed: ContractProcessResult) {
    try {
      return (failed.message || 'Error desconocido').split('-').map(m => m.trim()).filter(m => m.length > 0);
    } catch (err) {
      return [failed.message || 'Error desconocido'];
    }
  }

  closeModal() {
    this.store.dispatch(setModalContract({ modalContract: { isShow: false, arrayOfFaileds: [], arrayOfSuccess: [], isIndicators: false, typeModal: 0 } }));
  }

  getID(failed: ContractProcessResult) {
    return failed.orderId || "Sin ID";
  }

  getNumOfContract(failed: ContractProcessResult) {
    return failed.contractNumber;
  }

  getMessageError(failed: ContractProcessResult) {
    return failed.message || "Sin mensaje de error";
  }

}
